import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const ORDER_ADDITIONS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    ADMIN_ORDER_DYNAMIC_SERVICE_ADDITIONAL_FIELDS: (id: number) => `/admin-order-dynamic-service-additional-fields/${id}/`,
  }),
} as const;
